import { stripeProcessing } from '../stripeProcessing';
import { paymentsProcessingSlice } from './reducer.processing';
import { PaymentsProcessingService } from './service.processing';

export const { actions, reducer } = paymentsProcessingSlice;
export * as selectors from './selectors.processing';

export const paymentsProcessingService = new PaymentsProcessingService(
  stripeProcessing,
);
